import './src/common/styles/index.scss';

export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
  }
};
